import withStyles from '@material-ui/core/styles/withStyles'
import {
	useState,
} from 'react'
import { colorsNew } from 'root/src/client/web/commonStyles'
import classnames from 'classnames'
import { blackCardContext } from 'root/src/client/web/base/Card/BlackCard/contexts/blackCardContext'

const styles = {
	card: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		backgroundColor: 'rgba(0, 0, 0, .9)',
		filter: 'drop-shadow(9px 9px 10px rgba(0, 0, 0, 0.6))',
		margin: [[0, 10, 20]],
		color: 'white',
		borderRadius: 25,
		position: 'relative',
		overflow: 'hidden',
		boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
		transition: '0.1s',
		width: 320,
		height: 450,
		'&:hover, &:active, &:focus': {
			boxShadow: '0 1px 26px 0 rgba(0,0,0,1)',
		},
	},
	header: {
		width: '100%',
		height: '40%',
		overflow: 'hidden',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
	},
	separator: {
		zIndex: 1,
		display: 'flex',
		backgroundColor: colorsNew.dark1,
	},
	body: {
		overflow: 'hidden',
		height: '50%',
		display: 'flex',
		flexDirection: 'column',
		margin: [[0, 20]],
	},
	footer: {
		margin: [[15, 20, 15, 20]],
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	caption: {
		fontFamily: 'Roboto Mono',
		fontSize: 16,
		letterSpacing: '.02em',
		fontWeight: 700,
		color: '#00FFED',
		margin: 0,
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
	},
	highlightedSection: {
		display: 'flex',
		flexDirection: 'column',
	},
	highlightedSectionHeader: {
		color: colorsNew.teal,
		fontSize: 12,
		textTransform: 'uppercase',
		margin: '3px 0px',
	},
	highlightedSectionText: {
		color: colorsNew.light1,
		fontSize: 12,
		margin: '3px 0px',
	},
}

const withBlackCardStyle = withStyles(styles, { name: 'MuiBlackCard' })

export const Root = withBlackCardStyle(({ classes, children }) => {
	const [isHovered, setIsHovered] = useState(false)

	const contextValue = {
		isHovered,
		setIsHovered,
	}

	return (
		<blackCardContext.Provider value={contextValue}>
			<div
				className={classnames(classes.card)}
				onMouseEnter={() => {
					setIsHovered(true)
				}}
				onMouseLeave={() => {
					setIsHovered(false)
				}}
			>
				{children}
			</div>
		</blackCardContext.Provider>
	)
})

export const Header = withBlackCardStyle(({ classes, children, className, ...props }) => (
	<div className={classnames(classes.header, className)} {...props}>
		{children}
	</div>
))

export const Separator = withBlackCardStyle(({ classes, children, className, ...props }) => (
	<div className={classnames(classes.separator, className)} {...props}>
		{children}
	</div>
))

export const Body = withBlackCardStyle(({ classes, children, className, ...props }) => (
	<div className={classnames(classes.body, className)} {...props}>
		{children}
	</div>
))

export const Footer = withBlackCardStyle(({ classes, children, className, ...props }) => (
	<div className={classnames(classes.footer, className)} {...props}>
		{children}
	</div>
))

export const Caption = withBlackCardStyle(({ classes, title, className, ...props }) => (
	<p className={classnames(classes.caption, className)} {...props}>{title}</p>
))

export const HighlightedSection = withBlackCardStyle(({
	classes, title, text, ...props
}) => (
	<div className={classes.highlightedSection} {...props}>
		<div className={classes.highlightedSectionHeader}>{title}</div>
		<div className={classes.highlightedSectionText}>{text}</div>
	</div>
))
